import { render, staticRenderFns } from "./InventoryReservationView.vue?vue&type=template&id=7359db98"
import script from "./InventoryReservationView.vue?vue&type=script&lang=js"
export * from "./InventoryReservationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7359db98')) {
      api.createRecord('7359db98', component.options)
    } else {
      api.reload('7359db98', component.options)
    }
    module.hot.accept("./InventoryReservationView.vue?vue&type=template&id=7359db98", function () {
      api.rerender('7359db98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryReservationView.vue"
export default component.exports